import { useQuery } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { useParams } from 'react-router-dom'
import { fetchData } from 'src/api/api-utilities'

const fetchSessions = async (eventId) => {
  const response = await fetchData('/my_evanta/sessions/', { eventId })
  if (response.status < 200 || response.status > 300) {
    const error = new Error('Error')
    error.code = response.status
    error.info = response.data
    error.text = response.statusText
    throw error
  }
  return response.data
}

const useFetchSessions = () => {
  const { eventId } = useParams()
  const { data, isLoading } = useQuery({
    queryKey: [`sessions_${eventId}`],
    queryFn: () => fetchSessions(eventId),
    staleTime: Infinity,
    enabled: !!eventId,
    retry: false
  })
  const sessions = isEmpty(data) ? [] : data.sessions
  return {
    sessions,
    isLoadingSessions: isLoading
  }
}

export default useFetchSessions
